export default {
	title: "Gifts Redemption Center",
	myPoints: "My Points",
	SelectedGifts: "Selected Gifts",
	form: {
		label: {
			title: "Search",
			points: "Points"
		}
	},
	redemption: "Redeemed",
	stock: "Stock",
	id: {
		redeemPoints: "Redeem the required points：",
		btn: "Redeem Now",
		title: "Points Redemption Gift Notice",
		content: `Dear worker, thank you for your participation in the work.\n\nPlease read the following terms before redeeming points:\n\n[Work Points] After daily completion of order set data optimization, workers can earn 1 gift point, which can be used for partial gift sponsorship redemption.\n[Gift Redemption] Workers need to provide relevant shipping address information, and the gift will be shipped free of charge worldwide within 14 days. After the redemption is completed, you can contact customer service to obtain the tracking number to track the progress of the gift. The platform will not disclose information to third parties.\nNote: Once the points are redeemed for gifts, they cannot be refunded`
	},
	applyDialog: {
		title: "Receiving information",
		form: {
			consignee: "Consignee",
			area: "Area",
			telephone: "Telephone",
			deliveryAddress: "Delivery address"
		},
		btn: "Submit To"
	},
	records: {
		title: "Records",
		status: ["Pending Shipment", "Shipped", "Delivered", "Cancelled"]
	}
};
